import React from "react";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
//Limitless imports
import expertTerms from "../assets/expert-terms.png";
import expertPrivacy from "../assets/expert-privacy.png";
import expertConduct from "../assets/expert-conduct.png";
import { LegalTabs, useNavigation } from "@limitless/portal";
import { log as pilog } from "@limitless/common/utils";
import {
    fetchPlatformResources,
    EXPERT_TERMS,
    PRIVACY_POLICY,
    CODE_OF_CONDUCT,
    INTERNATIONAL_DATA_TRANSFER_ADDENDUM
} from "@limitless/common/apis/resource-api";
import { useExpertProfileContext } from "@limitless/expert";
import { recordPageView } from "@limitless/analytics";

const LEGAL_TABS_LABEL = [
    { label: "Terms & Conditions" },
    { label: "Privacy Policy" },
    { label: "Code of Conduct" },
    { label: "International Data Transfer Addendum" }
];
const legalItems = [
    {
        title: "Terms & Conditions",
        imageSource: expertTerms,
        backgroundColor: "#64b7b2",
        resource: EXPERT_TERMS
    },
    {
        title: "Privacy Policy",
        imageSource: expertPrivacy,
        backgroundColor: "#1099d6",
        resource: PRIVACY_POLICY
    },
    {
        title: "Code of Conduct",
        imageSource: expertConduct,
        backgroundColor: "#d1e6f7",
        resource: CODE_OF_CONDUCT
    },
    {
        title: "International Data Transfer Addendum",
        imageSource: expertConduct,
        backgroundColor: "#d1e6f7",
        resource: INTERNATIONAL_DATA_TRANSFER_ADDENDUM
    }
];

const LegalScreen = () => {
    const params = useParams();
    const [selectedContent, setSelectedContent] = React.useState("");
    const [selectedTab, setSelectedTab] = React.useState();
    const [loading, setLoading] = React.useState(false);

    const { profile } = useExpertProfileContext();
    const log = pilog.getLogger("LegalScreen");
    const location = useLocation();
    const { navigate } = useNavigation();

    React.useEffect(() => {
        if (params.selectedLegalItem && !selectedTab) {
            handleLegalItemClick(legalItems[params.selectedLegalItem]);
        }
    }, [params]);

    React.useEffect(() => {
        if (params.selectedLegalItem) {
            recordPageView(`User Agreements - ${legalItems[params.selectedLegalItem].title}`, location.pathname);
        }
    }, []);

    const handleLegalTabChange = legalItem => {
        setSelectedTab(legalItem);
        navigate("/legal");
        navigate(`/legal/${legalItem}`);
        handleLegalItemClick(legalItems[legalItem]);
    };

    const handleLegalItemClick = legalItem => {
        const { country, language } = profile;
        const userLocale = `${language}-${country}`;
        recordPageView(`User Agreements - ${legalItem.title}`, location.pathname);

        setLoading(true);

        fetchPlatformResources(
            { locale: userLocale, resourceList: [legalItem.resource] },

            response => processLegalContent(response),
            () => {
                processLegalContent([]);
                log.error(`Error retreiving content ${legalItem.contentLocation}`);
            }
        );
    };

    const processLegalContent = platformContent => {
        let selectedContent = "Content not found";

        if (platformContent.length === 1) {
            const resource = platformContent[0];
            if (resource.content) {
                selectedContent = resource.content;
            }
        }
        setSelectedContent(selectedContent);
        setLoading(false);
    };

    return (
        <LegalTabs
            tabsLabels={LEGAL_TABS_LABEL}
            tabsContent={selectedContent}
            selectedTab={parseInt(params.selectedLegalItem) || 0}
            loading={loading}
            onhandleclick={handleLegalTabChange}
        />
    );
};

export default LegalScreen;
